import React, { Suspense } from 'react';

const StripePaymentLazy = React.lazy(() => import('./StripePaymentLazy'));

const StripePayment = (props) => {
  return (
    <Suspense fallback={
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    }>
      <StripePaymentLazy {...props} />
    </Suspense>
  );
};

export default StripePayment;